import { createContext, FC } from 'react'
import { SearchParameters } from '../../../../constants'

const isInIFrame = () => {
  const { search } = window.location
  const searchParams = Object.fromEntries(new URLSearchParams(search))

  if (searchParams[SearchParameters.IFRAME] === 'true') {
    return true
  }

  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

const isFrameDetected = isInIFrame()
const context = createContext(isFrameDetected)
const { Provider } = context
const FrameDetectionProvider: FC = ({ children }) => <Provider value={isFrameDetected}>{children}</Provider>

export { FrameDetectionProvider, context as FrameDetectionContext }
